/**
 * Task utilities
 * @namespace TaskUtils
 */

import StringParser from "./stringParser";

export default class TaskUtils{

   /**
    * Get task users
    * @param {Array} taskUsers
    * @param {Number} maxUsers default 9999
    * @return users  
    */
    static getTaskUsers(taskUsers, maxUsers = 9999) {
        console.log(taskUsers?.assign_to_user, 'taskUsers');

        let users = [...taskUsers.task_users ||  [], taskUsers?.assign_to_user || null].filter(t => t)?.flat(1);

        users = [...users].map(mtu => {
            mtu.user_profile = '';
            let avatar = ''

            StringParser.extractUrl({string  : mtu?.user_avatar || mtu?.avatar || '', callback : url => {
                mtu.user_profile = url;
                avatar = url;
            }});

            /**
            * Set correct first name and last name property
            */
            mtu.first_name = mtu?.first_name || mtu?.user_first_name || mtu?.user_name || '';
            mtu.last_name = mtu?.last_name || mtu?.user_last_name || mtu?.user_name || '';

            return {...mtu, avatar};
        })


        return users.slice(0, maxUsers);
    }
}